import { Component } from '@angular/core';

import { AuthService, MainConfig, Section } from '../core';

@Component({
  selector: 'atn-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent {
  name: string = '';
  logo: string = '';
  logoHeight: string = '';
  sections: Array<Section> = [];

  constructor(public authService: AuthService, private mainConfig: MainConfig) {
    this.name = mainConfig.cmsName;
    this.logo = mainConfig.topBarLogo;
    this.logoHeight = mainConfig.topBarLogoHeight;
    this.sections = mainConfig.mainMenuSections;
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms/src/layout/layout.component.ts